<template>
  <div class="page">
    <div class="main-content">
      <vue-headful
        title="EVAPAPA - Web Developer"
        description="Front-end web development by Evangeline Papanicola."
      />
      <Nav />
      <MobileNav />
      <carousel
        class="carousel"
        :scrollPerPage="true"
        :perPage="1"
        :autoplay="true"
        :autoplayTimeout="4000"
        :autoplayHoverPause="true"
        :paginationActiveColor="'#73081A'"
        :paginationColor="'#A70D27'"
        :paginationSize="12"
        :loop="true"
      >
        <slide>
          <router-link to="/portfolio"
            ><img
              alt="EVAPAPA Main Banner"
              class="slide-img"
              src="../assets/mainbanner.png"
          /></router-link>
        </slide>
        <slide>
          <a href="https://suzydesign.co.uk/"
            ><img
              alt="Suzy Design Website"
              class="slide-img"
              src="../assets/suzydesign-banner.png"
          /></a>
        </slide>
        <slide>
          <a href="https://bakery-future-tech.netlify.app/"
            ><img
              alt="Bakery Website"
              class="slide-img"
              src="../assets/bakery-banner.png"
          /></a>
        </slide>
        <slide>
          <a href="https://arthurconan.netlify.app/"
            ><img
              alt="Arthur-Conan App"
              class="slide-img"
              src="../assets/arthur-conan-banner.png"
          /></a>
        </slide>
      </carousel>
      <div class="full-width-container">
        <div class="standard-text" style="margin-top:20px;">
          I'm Evangeline Papanicola - a Digital Media graduate with experience
          in front-end web development, design and skilled in using the Adobe
          Creative Cloud software.
        </div>
        <div class="subheading" style="margin-bottom:20px;">
          Scroll to find out more.
        </div>
        <br />
      </div>
      <div class="grid-container">
        <div data-aos="fade-right">
          <h1>WORK EXPERIENCE</h1>
          <div class="subheading">
            JUNIOR ELEARNING DEVELOPER -
            <a class="subheading-link" href="https://wearesponge.com/">SPONGE</a
            ><br />2018-2019 (13 MONTHS)
          </div>
          <div class="standard-text">
            I worked as a front-end developer on projects for a variety of large
            clients including Tesco, the NHS and AstraZeneca. I worked to create
            elearning using technologies such as the Adapt framework, as well as
            software such as Articulate Storyline.
          </div>
          <div class="subheading">
            ARTHUR CONAN DOYLE COLLECTION<br />PORTSMOUTH CENTRAL LIBRARY<br />2019-2020
          </div>
          <div class="standard-text">
            I worked in a small team to develop a Progressive Web App for the
            Arthur Conan Doyle Collection. The application provides a live map
            of Portsmouth that pinpoints historical locations related to Arthur
            Conan Doyle's life.
            <a class="body-link" href="https://arthurconan.netlify.app/"
              >Try it out!</a
            >
          </div>
          <div class="subheading">
            FREELANCE WEB DEVELOPER<br />CLIENT:
            <a class="subheading-link" href="https://suzydesign.co.uk/"
              >SUZY DESIGN</a
            ><br />2019-2020
          </div>
          <div class="standard-text">
            I developed a website using Vue.js for Suzy Design, a graphic
            designer based in Exmouth, Devon.
          </div>
        </div>
        <div data-aos="fade-left" class="skills">
          <h1>SKILLS</h1>
          <img class="skillsimg" src="../assets/skills-list.png" alt="skills" />
        </div>
        <div data-aos="fade-right">
          <h1>QUALIFICATIONS</h1>
          <div class="subheading">UNIVERSITY OF PORTSMOUTH, 2016-2020</div>
          <div class="standard-text">
            BSc (Hons) Digital Media<br />Course involves the production of
            high-quality websites, as well as animation, 2D and 3D graphics,
            video, and media streaming, to create digital media products. You
            can view some of my university projects via my
            <router-link class="body-link" to="/portfolio"
              >portfolio</router-link
            >. <br /><br />
            Predicted First.
            <div class="subheading">EXETER COLLEGE, 2014-2016</div>
            <div class="standard-text">
              A Level Mathematics - A<br />A Level German - B<br />AS Level
              Computing - C
            </div>
            <div class="subheading">TRINITY SCHOOL, TEIGNMOUTH 2009-2014</div>
            <div class="standard-text">
              10 GCSEs grade A-C including Mathematics (A) and English Language
              (C).
            </div>
          </div>
        </div>
        <div data-aos="fade-left">
          <h1>INTERESTS</h1>
          <div class="standard-text" style="margin-top:20px;">
            <span style="font-weight: 700;">Gaming</span> is something I have
            always had an avid interest in, and I know I’ll never stop keeping
            myself updated on industry news and the newest, trending games.
            During my placement year, I developed a
            <a
              class="body-link"
              href="https://evangelinepapanicola.itch.io/nox-caelo"
              target="_blank"
              rel="noopener"
              >text adventure</a
            >
            game in my free time.
          </div>
          <div class="standard-text">
            At University, I was part of both the Portsmouth Gaming and Esports
            Society, where I represented Portsmouth University in various
            Overwatch teams for
            <a
              class="body-link"
              href="https://thenuel.com/"
              target="_blank"
              rel="noopener"
              >NUEL</a
            >
            and
            <a
              class="body-link"
              href="https://nse.gg/"
              target="_blank"
              rel="noopener"
              >NSE</a
            >.
          </div>
          <div class="standard-text">
            I also thoroughly enjoy
            <span style="font-weight:700;">Pilates</span>, and attend classes on
            a weekly basis.
          </div>
        </div>
      </div>
      <div class="centered-container">
        <a class="cv-button" href="pdf/CV.pdf" target="_blank" rel="noopener"
          >DOWNLOAD MY CV</a
        >
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from "@/components/Nav.vue";
import MobileNav from "@/components/MobileNav.vue";
import Footer from "@/components/Footer.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "Home",
  components: {
    Nav,
    MobileNav,
    Carousel,
    Slide,
    Footer
  }
};
</script>
